<template>
    <div class="container-fluid">
        <div class="row">
            <Menu />
            <div class="col-md-10 mt-4">
                <h1>
                    <i class="fa-solid fa-buildings"></i> Recuperandas Cadastradas        
                    <RouterLink style="float:right; position:relative; top:-10px;" to="/recuperanda/novo" class="btn btn-primary">+ NOVO</RouterLink>
                </h1> 
                <hr />
                <div class="cont">
                    <Loading v-if="exibeLoading" />
                    <table v-if="!exibeLoading" class="table">
                        <thead>
                            <tr>
                                <th scope="col">Nome</th>
                                <th scope="col">CNPJ</th>
                                <th scope="col">Editar</th>
                                <th scope="col">Excluir</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="dados.length > 0" v-for="reck in dados" :key="reck.id">
                                <td v-if="idEmEdicao !== reck.id">{{ reck.name }}</td>
                                <td v-else>
                                    <form @submit.prevent="salvarEdicao(reck.id)">
                                        <div class="row">
                                            <input
                                                style="height:40px !important; width:500px !important"
                                                type="text"
                                                class="form-control col-md-5"
                                                v-model="novoNomeEditar"
                                            />
                                            <button class="btn btn-primary col-md-2" style="margin-left:10px;">Salvar</button>
                                            <button type="button" class="btn btn-secondary col-md-2" @click="cancelarEdicao" style="margin-left:10px;">Cancelar</button>
                                        </div>
                                    </form>
                                </td>
                                <td>{{ reck.cnpj }}</td>
                                <td v-if="idEmEdicao !== reck.id">
                                    <i @click="iniciarEdicao(reck.id)" style="cursor: pointer;" class="fa-sharp fa-thin fa-pen-to-square"></i>
                                </td>
                                <td v-else></td> 

                                <td><i @click="removeRecuperanda(reck.id)"  style="cursor: pointer;" class="fa-light fa-trash"></i></td>
                            </tr>
                            <tr v-else>
                                <td colspan="3">
                                    <div class="alert alert-warning mt-3">Nenhuma classe cadastrada</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Menu from "@/components/Menu.vue";
import recuperanda from "@/servicos/recuperanda";
import { RouterLink } from "vue-router";

const dados = ref([]);
const idEmEdicao = ref(null); // Controla o ID em edição
const novoNomeEditar = ref("");
const exibeLoading = ref(false);

// Carregar classes
const exibeRecuperanda = async () => {
    exibeLoading.value = true;
    const response = await recuperanda.getAll();
    dados.value = response.data;
    exibeLoading.value = false;
};

// Remover classe
const removeRecuperanda = async (id) => {
    if(window.confirm("Deseja realmente remover essa recuperanda?")){
        try {
            await recuperanda.deleteRecuperanda(id);
            exibeRecuperanda();
        } catch(error){
            alert(error.response.data.message)
        }
    }
};

// Iniciar edição
const iniciarEdicao = async (id) => {
    const response = await recuperanda.show(id);
    novoNomeEditar.value = response.data.name;
    idEmEdicao.value = id; // Marca o ID em edição
};

// Salvar alterações
const salvarEdicao = async (id) => {
    await recuperanda.updateRecuperanda(id, novoNomeEditar.value);
    idEmEdicao.value = null; // Finaliza a edição
    exibeRecuperanda();
};

// Cancelar edição
const cancelarEdicao = () => {
    idEmEdicao.value = null;
    novoNomeEditar.value = "";
};

onMounted(() => {
    exibeRecuperanda();
});
</script>

<style>
h1 { color:rgba(0,0,0,.8); font-weight: 400; font-size:20px !important; }
/* .table>:not(caption)>*>* { background-color:#1B3639; } */
th { color:rgba(255,255,255,.9) !important; padding:10px !important; background-color: #1B3639 !important; }
.cont { background:#fff; padding: 10px; border:1px solid rgba(0,0,0,.1); box-shadow:1px 2px 3px rgba(0,0,0,.4); }
</style>
